import HelpIcon from '@mui/icons-material/Help'
import { Button } from '@mui/material'
import pdfFile from './ComplaintTrendsOverview.pdf'


export default function ComplaintTrendsHelp() {
  const file = typeof pdfFile === 'string' ? pdfFile : pdfFile?.default

  return (
    <Button
      component='a'
      href={file}
      target='_blank'
      rel='noopener noreferrer'
      variant='text'
      className='help-button'
      startIcon={<HelpIcon />}
      disabled={!file}
    >
      Help
    </Button>
  )
}